import React, { useState } from 'react';
import { useModalDismiss } from '../../../hooks/useModalDismiss';
import type { Volume } from '../../../types';

export function VolumeModal({ volume, onClose, onSave }: { volume?: Volume; onClose: () => void; onSave: (title: string, description: string) => void }) {
  const [title, setTitle] = useState(volume?.title || '');
  const [description, setDescription] = useState(volume?.description || '');
  const dismiss = useModalDismiss(onClose);

  return (
    <div className="modal-overlay" {...dismiss}>
      <div className="modal-content">
        <h2 className="modal-title">{volume ? '编辑分卷' : '新建分卷'}</h2>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="分卷名称" className="modal-input" autoFocus />
        <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="分卷简介（可选）" className="modal-textarea" rows={4} />
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel">取消</button>
          <button onClick={() => onSave(title, description)} disabled={!title.trim()} className="btn-confirm">确定</button>
        </div>
      </div>
    </div>
  );
}

export function CreateChapterModal({ onClose, onSave }: {
  onClose: () => void;
  onSave: (title: string, summary: string, content: string) => void;
}) {
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const dismiss = useModalDismiss(onClose);

  return (
    <div className="modal-overlay" {...dismiss}>
      <div className="modal-content">
        <h2 className="modal-title">新建章节</h2>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="章节名称" className="modal-input" autoFocus />
        <textarea value={summary} onChange={e => setSummary(e.target.value)} placeholder="章节摘要（可选，创建后可在编辑器中补充）" className="modal-textarea" rows={3} />
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel">取消</button>
          <button
            onClick={() => onSave(title, summary, '')}
            disabled={!title.trim()}
            className="btn-confirm"
          >
            创建并编辑
          </button>
        </div>
      </div>
    </div>
  );
}
